import React from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import styles from './DeleteFieldBtn.module.scss';

const DeleteFieldBtn = ({ onClick, className, type = 'danger' }) => {
  return (
    <Button
      icon="minus-circle"
      ghost
      onClick={onClick}
      type={type}
      className={cn(styles.root, className)}
    />
  );
};

export default DeleteFieldBtn;
